<template>
  <div id="app">
    <div id="nav">
        Debug: 
      <router-link to="/">intro</router-link> |
      <router-link to="/tutorial">Tutorial</router-link> |
      <router-link to="/game">game</router-link> |
      <router-link to="/outro">outro</router-link>
    </div>
    <transition name="router-anim">
      <router-view :key="bustCache()"/>
    </transition>
  </div>
</template>
<script>
export default {
    methods: {
        bustCache() {
            return Date.now();
        }
    }
}
</script>

<style lang="scss">
    html { height: 100%; -webkit-tap-highlight-color: transparent; }
    body {
        margin: 0;
        background: linear-gradient(-45deg,#efaa54 0%, #ce456d 100%) no-repeat fixed;
        font-family:Arial, Helvetica, sans-serif;
    }

    #app {
        width: 100%;
        max-width: 530px;
        position: absolute;
        top:0;
        left: 50%;
        transform:translateX(-50%);
        height: 100%;
        max-height: 740px;

        margin: auto;    
    }
    .page {
        position: absolute;
        top:0;
        left: 0;
        width:100%;
    }
    #nav {
        display:none;
        position: fixed;
        top:0;
        left:0;
        z-index: 1000;
        // bottom: -10px;
    }
  
    .router-anim-enter-active {
        animation: coming 1s;
        animation-delay: .5s;
        opacity: 0;
    }
    .router-anim-leave-active {
        animation: going 1s;
    }

    @keyframes going {
        from {
            transform: translateX(0);
        }
        to {
            opacity: 0;
        }
    }
    @keyframes coming {
        from {
            opacity: 0;
        }
        to { 
            opacity: 1;
        }
    }
</style>
